<template>
    <div>
        <vs-tabs class="w-full">
            <vs-tab label="Details">
                <vx-input
                    v-model="practice.name"
                    name="practice name"
                    placeholder="Practice Name"
                    label="Practice Name"
                    required
                    class="w-full"
                    remove-validation-padding
                />
                <vx-divider />
                <div v-if="!isValid" style="color: rgb(234, 84, 85); font-size: x-small">
                    At least one method of communication is required *
                </div>
                <vx-phone-input
                    class="w-full"
                    label="Phone"
                    v-model="practice.phone"
                ></vx-phone-input>
                <vx-phone-input class="w-full" label="Fax" v-model="practice.fax"></vx-phone-input>
                <vx-email-input
                    class="w-full"
                    label="Email Address"
                    v-model="practice.emailAddress"
                ></vx-email-input>
            </vs-tab>
            <vs-tab class="w-full" label="Address">
                <vx-address-form
                    v-model="practice.address"
                    required
                    v-validate="['required']"
                ></vx-address-form>
            </vs-tab>
            <vs-tab class="w-full" label="Notes">
                <vx-textarea
                    label="Additional Notes"
                    name="notes"
                    icon-pack="feather"
                    icon="icon-file-text"
                    :disabled="false"
                    class="w-full text-area-height mb-8"
                    v-model="practice.additionalNotes"
                    remove-validation-padding
                />
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'practice-form',
    components: {},
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            prefilledFormData: null
        }
    },
    watch: {},
    computed: {
        ...mapGetters({
            getStateByCode: 'maarima/getStateByCode'
        }),

        isValid() {
            return (
                !!this.practice.name &&
                !!this.practice.address &&
                (!!this.practice.phone || !!this.practice.fax || !!this.practice.emailAddress)
            )
        },
        practice: {
            get() {
                return this.value
            },
            set(v) {
                return this.$emit('input', v)
            }
        }
        // address: {
        //     get() {
        //         return this.practice.address
        //     },
        //     set(v) {
        //         this.practice.address = v
        //     }
        // }
    }
}
</script>
